module.exports = __webpack_public_path__ + "static/media/expand.41e61926.svg";